/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace */

import {
  Component,
  OnInit,
  ViewChild
} from '@angular/core';

import { Logger                } from '@/util/logger';
import { MatSidenav }            from "@angular/material/sidenav";
import { IUserRow }              from "@/screens/administration/i.user.row";
import { UserService }           from '@/services/user.service';

import { PrimeIcons }            from "primeng/api";
import { SortEvent }             from 'primeng/api';

import {first} from "rxjs/operators";

@Component({
  templateUrl: 'pending.users.page.component.html'
})

/**
 *
 * @class PendingUsersPageComponent
 *
 * @brief sub-list of the users that need to be approved
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      March 2021
 *
 */
export class PendingUsersPageComponent implements OnInit {

  @ViewChild('adminsidenav')
  public         nav: MatSidenav;

  /** the list of CSV style entries for each usser in the system */
  public userList: IUserRow[] = [];


  /** standard constructor */
  constructor(
    private users: UserService
  ) {

  }

  /** open or close the side nav panel */
  toggleSidebar() {

    this.nav.toggle();
  }

  /** on page setup, create the form validator */
  ngOnInit() {

    Logger.debug('[PendingUserPage] init...');

    /* fetch the user dump... */

    let pu: PendingUsersPageComponent = this;

    pu.users.dump()
      .pipe(first())
      .subscribe(
        (rows: IUserRow[]) => {

          Logger.debug(`[PendingUserPage] users: `, rows);

          pu.userList = rows.filter((item: IUserRow) => item.is_pending);

        },
        error => {

          Logger.error(`[PendingUserPage] could not fetch user report: `, error);

        });

  }

}
